<div class="container">
    <h2>Pillars of the Community</h2>

    <mat-form-field class="filter-form-field">
      <mat-label>Search</mat-label>
      <input matInput type="text" (keyup)="applySearchFilter($event)" [(ngModel)]="value">
      @if (value) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearchFilter()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <mat-form-field class="sort-form-field">
      <mat-label>Sort By</mat-label>
      <mat-select (selectionChange)="sortModels($event.value)">
        <mat-option value="nameAscending">Name: A - Z</mat-option>
        <mat-option value="nameDescending">Name: Z - A</mat-option>
      </mat-select>
    </mat-form-field>

    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <ng-container *ngIf="!dataLoading; else skeletonCards">
        <div *ngFor="let model of filteredModels">
          <mat-card class="product-card" appearance="outlined" [routerLink]="['/models', model.model_id]" style="cursor: pointer;" tabindex="0" role="button" [attr.aria-label]="'View details for ' + model.name">
            <div class="image-container" style="position: relative;">
              <img mat-card-image
                [src]="model.profile_image_url ? model.profile_image_url : (model.gender === 'Male' ? 'assets/images/placeholder_male_profile_image.png' : 'assets/images/placeholder_profile_image.png')"
                (load)="onImageLoad(model.model_id)"
                (error)="onImageError(model.model_id)"
                [style.visibility]="imageLoading[model.model_id] ? 'hidden' : 'visible'">
              <div *ngIf="imageLoading[model.model_id]" class="spinner-overlay">
                <mat-spinner diameter="40" aria-label="Loading image"></mat-spinner>
              </div>
            </div>
            <div class="card-content">
              <div class="card-header">
                <mat-card-title>{{model.name}}</mat-card-title>
                <mat-card-subtitle>{{model.age}}</mat-card-subtitle>
              </div>
              <p class="description-ellipsis">{{model.description}}</p>
              <div class="model-stats-row" *ngIf="!imageLoading[model.model_id]">
                <div class="stat">
                  <mat-icon fontSize="16">favorite_border</mat-icon>
                  <span>{{ model.likesCount }}</span>
                </div>

                <div class="stat">
                  <mat-icon fontSize="16">visibility</mat-icon>
                  <span>{{ model.viewsCount ?? 0 }}</span>
                </div>

                <div class="stat">
                  <mat-icon fontSize="16">image</mat-icon>
                  <span>{{ model.imagesCount ?? '—' }}</span>
                </div>

                <div class="stat">
                  <mat-icon fontSize="16">videocam</mat-icon>
                  <span>{{ model.videosCount ?? '—' }}</span>
                </div>
              </div>
            </div>
          </mat-card>
        </div>
      </ng-container>
      <ng-template #skeletonCards>
        <div *ngFor="let i of [1,2,3,4,5,6]">
          <mat-card class="product-card" appearance="outlined">
            <div class="image-container" style="position: relative;">
              <app-skeleton [width]="270" [height]="180" [borderRadius]="8"></app-skeleton>
            </div>
            <div class="card-content">
              <div class="card-header">
                <app-skeleton [width]="160" [height]="24" [borderRadius]="6" style="margin-bottom: 8px;"></app-skeleton>
                <app-skeleton [width]="80" [height]="18" [borderRadius]="6"></app-skeleton>
              </div>
              <app-skeleton [width]="220" [height]="16" [borderRadius]="6" style="margin-bottom: 12px;"></app-skeleton>
              <div style="display: flex; gap: 8px;">
                <app-skeleton [width]="100" [height]="32" [borderRadius]="16"></app-skeleton>
              </div>
            </div>
          </mat-card>
        </div>
      </ng-template>
    </div>
</div>



